import { Injectable, Signal, resource } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ExportDataService } from '@services/core-services/export-data.service';
import { Query } from '@services/core-services/models/query';
import { PaginatedList } from '@services/core-services/models/paginated-list';
import { ExportData } from '@services/core-services/models/export-data.modal';

@Injectable()
export class DownloadsDataStore {
  private currentList: ExportData[] = [];
  private currentPage = 1;
  private lastRequestedPage = 1;

  constructor(private readonly exportService: ExportDataService) {}

  public createDownloadsResource(page: Signal<number>, limit: Signal<number>) {
    return resource({
      params: () => ({
        page: page(),
        limit: limit(),
      }),
      loader: async ({ params }): Promise<PaginatedList<ExportData[]> | undefined> => {
        const query: Query = {
          page: params.page,
          limit: params.limit,
        };

        const newData = await firstValueFrom(this.exportService.downloadDataList(query));
        const list = newData.list || [];

        if (params.page < this.lastRequestedPage) {
          return {
            ...newData,
            list: this.currentList,
          };
        }

        if (params.page === 1) {
          this.currentList = list;
          this.currentPage = 1;
        } else if (params.page === this.currentPage + 1) {
          this.currentList = [...this.currentList, ...list];
          this.currentPage = params.page;
        }

        this.lastRequestedPage = params.page;

        if (this.currentList.length === 0 && params.page === 1) {
          return undefined;
        }

        return {
          ...newData,
          list: this.currentList,
        };
      },
    });
  }
}
